<template>
    <a
        class="button"
        @click="inputAction"
        :class="{ 'invalid-button-after': focusedOut && invalid }"
    >
        <!-- Caso seja uma imagem baixada -->
        <svg class="svg-icons" v-if="iconSvg">
            <use :xlink:href="require(`@/assets/img/icons/${icon}.svg`) + '#layer'" />
        </svg>
        <!-- Caso seja do buefy -->
        <b-icon :icon="icon" v-else />
    </a>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
        },
        iconSvg: {
            type: Boolean,
        },
        focusedOut: {
            type: Boolean,
        },
        invalid: {
            type: Boolean,
        },
    },
    methods: {
        inputAction() {
            this.$emit('inputAction');
        },
    },
};
</script>
